export function useCompany() {
  const company = useState<components['schemas']['Company'] | null>(
    'company',
    () => null
  )

  const getCompany = async () => {
    const { $api } = useNuxtApp()

    return await $api<components['schemas']['Company']>(`/company/`)
      .then((response) => (company.value = response))
      .catch((error) => {
        throw createError({
          statusCode: 400,
          statusMessage: error.data?.detail,
        })
      })
  }

  return { company, getCompany }
}
